
import Vue from "vue";
import BillingInfo from "@/components/BillingInfo.vue";
import InvoiceMain from "@/components/InvoiceMain.vue";
import ReviewPayment from "@/components/ReviewPayment.vue";
import axios from "axios";
import { UI_ENDPOINT } from "../constants/EndPoints";
import store from "../store";
import { mapGetters } from "vuex";
import { IAppProperties, IInvoiceData, IAuthBasic } from "../types";
import AuthBasic from "../data/authBasic";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";

export default Vue.extend({
  name: "home",
  mixins: [AppPropsMixin],
  components: {
    BillingInfo,
    InvoiceMain,
    ReviewPayment
  },
  data() {
    return {
      stepperIndex: 1 as number,
      loadingHomeMainText: false as boolean
    };
  },
  computed: {
    invoices(): IInvoiceData[] {
      //@ts-ignore
      return store.getters.invoiceModule.getInvoiceData;
    },
    isFormValid(): boolean {
      let formValid: boolean = true;
      switch (this.stepperIndex) {
        case 2:
          //@ts-ignore
          formValid = this.appProps.validInvoice;
          formValid = this.invoices.length > 0;
          break;
        case 3:
          //@ts-ignore
          formValid = this.appProps.validBillingInfo;
          break;
      }

      return formValid;
    }
  },
  created() {
    //@ts-ignore
    if (this.appProps.homeMainHTML.length < 1) {
      this.loadingHomeMainText = true;
      let url = UI_ENDPOINT.GET_HOME_MAIN_TEXT;

      let that: any = this;
      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.homeMainHTML = response.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loadingHomeMainText = false;
        });

      url = UI_ENDPOINT.GET_FINANCE_EMAIL;

      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.financeEmail = response.data;
        })
        .catch(error => {})
        .finally(() => {});

      url = UI_ENDPOINT.GET_PP_MAX_MONTHS;

      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.paymentPlanMaximumMonths = response.data;
        })
        .catch(error => {})
        .finally(() => {});

      url = UI_ENDPOINT.GET_PP_QUALIFYING_INVOICE_REFERENCE_PREFIX;

      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.paymentPlanQualifyingInvoiceReferencePrefix = response.data;
        })
        .catch(error => {})
        .finally(() => {});

      url = UI_ENDPOINT.GET_PP_REQUEST_FORM_VERBIAGE;

      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.requestFormVerbiage = response.data;
        })
        .catch(error => {})
        .finally(() => {});

      url = UI_ENDPOINT.GET_PP_DOES_NOT_QUALIFY_VERBIAGE;

      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.doesNotQualifyVerbiage = response.data;
        })
        .catch(error => {})
        .finally(() => {});
    }
  },
  methods: {
    scrollToTop() {
      this.$vuetify.goTo(0, { duration: 500 });
    },
    saveToStore() {
      switch (this.stepperIndex) {
        case 2:
          //@ts-ignore
          this.$refs.invoiceMain.saveInvoiceToStore();
          break;
        case 3:
          //@ts-ignore
          this.$refs.billingInfo.saveBillingToStore();
          break;
      }
    },
    navigate(direction: string) {
      this.saveToStore();

      if (direction === "forward") {
        if (
          this.stepperIndex === 1 ||
          //@ts-ignore
          (this.stepperIndex === 3 && this.$refs.formBillingInfo.validate()) ||
          //@ts-ignore
          (this.stepperIndex === 2 && this.$refs.formInvoiceMain.validate())
        ) {
          this.stepperIndex = this.stepperIndex + 1;
          Vue.nextTick(this.scrollToTop);
        }
      } else {
        this.stepperIndex = this.stepperIndex - 1;
        Vue.nextTick(this.scrollToTop);
      }

      //@ts-ignore
      if (this.stepperIndex === 4 && this.$refs.formBillingInfo.validate()) {
        this.getFormForPayeezy();
      }
    },
    getFormForPayeezy() {
      //@ts-ignore
      this.$refs.reviewScreen.getFormToSubmit();
    },
    enterCeditCard() {
      //@ts-ignore
      if (!this.appProps.failedPayeezyFormCreation) {
        //@ts-ignore
        this.$refs.reviewScreen.submitPayeezyForm();
      } else {
        //@ts-ignore
        this.$refs.reviewScreen.getFormToSubmit();
      }
    }
  }
});
